import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { User } from '../../auth/user.model';
import { InvoiceService } from '../../invoice/invoice.service';
import { AuthService } from '../../auth/auth.service';
import { MatDialog } from '@angular/material';
import { UIService } from '../../shared/ui.service';
import { Subscription } from 'rxjs/index';
import { Invoice, Order } from '../../order/order.model';
import { ActivatedRoute, Router } from '@angular/router';
import { PicturesComponent } from '../../invoice/invoice-details/dialog/pictures/pictures.component';

@Component({
  selector: 'app-order-invoice-detail',
  templateUrl: './order-invoice-detail.component.html',
  styleUrls: ['./order-invoice-detail.component.css']
})
export class OrderInvoiceDetailComponent implements OnInit, OnDestroy {

  user: User;
  invoice: Invoice;
  order: Order;
  isLoading = false;
  private loadingSubscription: Subscription;
  private selectedProjectSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private invoiceService: InvoiceService,
    private authentication: AuthService,
    public dialog: MatDialog,
    private uiService: UIService,
    private _ref: ChangeDetectorRef,
  ) { }

  ngOnInit() {

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
      this._ref.markForCheck();
    });

    this.selectedProjectSubscription = this.uiService.selectedProjectChanged.subscribe(projectId => {
      this.router.navigate(['/invoices']);
    });

    this.user = this.authentication.getUser();

    this.route.paramMap.subscribe(params => {

      const orderId = params.get('orderId');
      const invoiceId = params.get('invoiceId');
      this.invoiceService.getInvoiceAndOrderById(this.user.token, orderId, invoiceId).subscribe(response => {
        this.invoice = response['invoice'];
        this.order = response['order'];
        this.uiService.loadingStateChanged.next(false);
      });
    });
  }

  openImagesDialog(){
    const dialogRef = this.dialog.open(PicturesComponent, {
      data: this.order,
    });
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.selectedProjectSubscription.unsubscribe();
  }

}
